import React from 'react';

const Payment = () => {
    return (
        <div>
            <h2>Payment Mathod Coming Soon...</h2>
        </div>
    );
};

export default Payment;